import React, { useContext, useState } from "react";
import PrimaryButton from "../common/PrimaryButton";
import RecruitmentModal from "./RecruitmentModal";
import { AuthContext } from "../../context/AuthContext";

type PositionProps = {
  heading: string;
  description: string;
};

const position: PositionProps[] = [
  {
    heading: "Content Writer",
    description: "We’re looking for a content writer to join our team.",
  },
  // {
  //   heading: "Brand Strategist",
  //   description:
  //     "We’re looking for a brand strategist to join our team. We value creativity and innovation.",
  // },
  // {
  //   heading: "Video Editor",
  //   description: "We’re looking for a video editor to join our team.",
  // },
  // {
  //   heading: "Business Development Executive",
  //   description:
  //     "We’re looking for a business development executive to join our team.",
  // },
];

const Position = () => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [positions, setPositions] = useState<PositionProps[]>(position);

  const dataContext = useContext(AuthContext);

  if (!dataContext) return null;
  const { theme } = dataContext;

  return (
    <div className="w-full py-6 sm:py-20 px-4 sm:px-6 lg:px-8">
      <h2
        className={`${
          theme === "dark" ? "text-white" : "text-white"
        } text-4xl font-extrabold font-montserrat mb-4 sm:mb-8 sm:text-5xl transition-all duration-500 text-center sm:text-start`}
      >
        Open Positions
      </h2>
      <div className=" flex flex-col gap-10">
        {positions.map((post, index) => (
          <div
            key={index}
            className={`${
              theme === "dark" ? "bg-white" : "card-gradient"
            } p-[1px] transition-all duration-500 rounded-[20px]`}
          >
            <div
              className={`${
                theme === "dark"
                  ? "bg-primary text-white"
                  : "bg-[#141414] text-white"
              } flex flex-col sm:flex-row justify-between transition-all duration-500 rounded-[20px] h-full pb-8 sm:pb-0 items-center sm:items-start`}
            >
              <div className="py-4 sm:py-6 px-7 font-montserrat">
                <h3 className="text-3xl font-gtAmerica font-bold mb-2 text-center sm:text-left">
                  {post.heading}
                </h3>
                <p className="font-gtAmerica mb-4 text-lg font-medium text-center sm:text-left">
                  {post.description}
                </p>
                <div className="flex flex-row gap-4 justify-between sm:justify-start sm:gap-10 items-center sm:items-start">
                  <div
                    className={`${
                      theme === "dark" ? "border-white" : "border-secondary"
                    } rounded-full  px-4 py-2 border font-semibold font-gtAmerica sm:text-lg w-fit`}
                  >
                    Work from Office
                  </div>
                  <div
                    className={`${
                      theme === "dark" ? "border-white" : "border-secondary"
                    } rounded-full px-4 py-2 border font-semibold font-gtAmerica sm:text-lg w-fit`}
                  >
                    Full-Time
                  </div>
                </div>
              </div>
              <div
                className={`${
                  theme === "dark" ? "bg-secondary" : "card-gradient"
                } p-[1px] h-fit w-fit rounded-lg sm:ml-0 sm:mt-10 sm:mr-10`}
              >
                <PrimaryButton
                  onClick={() => {
                    setTitle(post.heading);
                    setIsOpen(true);
                  }}
                  className={`${
                    theme === "dark"
                      ? " bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                      : " bg-white !text-black hover:shadow-[0_0_10px_2px] hover:shadow-secondary inset-0 hover:!text-white hover:bg-secondary"
                  } relative bg-primary font-gtAmerica`}
                >
                  Apply Now
                </PrimaryButton>
              </div>
            </div>
          </div>
        ))}
      </div>
      <RecruitmentModal
        isOpen={modalIsOpen}
        setIsOpen={setIsOpen}
        title={title}
      />
    </div>
  );
};

export default Position;
